// extracted by mini-css-extract-plugin
export var button = "Button-module--button--8565a";
export var outlinedButton = "Button-module--outlined-button--425e1";
export var sendButton = "Button-module--send-button--5efb1";